import { FC, ReactNode } from 'react'
import { IonIconPicker, IonIconPickerType } from './IonIconPicker'
import { IonIconRender, IonIconRenderType } from './IonIconRender'

const SBIonIcon: FC & IonIconPickerType & IonIconRenderType = (): ReactNode => (
  <></>
)

SBIonIcon.Picker = IonIconPicker
SBIonIcon.Render = IonIconRender

export default SBIonIcon
